<template>
  <div class="active-basic">
    <div class="common-form">基本信息</div>


          <div v-if="form.code == 'ad'">

            <el-form-item label="修改广告图片" prop="image_id" :rules="rulesImage">
            <div class="d-c-c ad-picture" @click="openUpload">
              <img v-if="form.image_url" :src="form.image_url" width="300" height="124" />
              <span v-else class="el-icon-picture-outline"></span>
            </div>
            <p class="ml10 gray">提示：图片尺寸建议750x310</p>
          </el-form-item>

              
            <el-form-item label="选择跳转路径" prop="page_url" >
              <div class="url-box flex-1">
                  <span class="key-name">跳转地址：</span>
                  <el-input
                    placeholder="请选择跳转地址"
                    :value="form.page_url.name"
                  ></el-input>
                </div>
              
            
              <el-button type="primary" @click="changeLink(index)"
                    >选择链接</el-button
                  >

            </el-form-item>
          </div>

          <div v-if="form.code == 'keyword'">
            <el-form-item label="关键字" prop="keyword" >
                  <div>{{ form.keyword }}</div>
              </el-form-item>
            <!-- 选择商品 -->
              <el-form-item label="商品" prop="phone" >
                  <el-button type="primary" @click="addProduct()">选择商品</el-button>
                  <div>选择的产品：{{ form.product_name }}</div>
              </el-form-item>
          </div>
  

          <div v-if="form.code == 'store'"> 
              <!-- 选择商品 -->
                <el-form-item label="商品" prop="phone" >
                    <el-button type="primary" @click="addProduct()">选择商品</el-button>
                    <div>选择的产品：{{ form.product_name }}</div>
                </el-form-item>
            </div>
    
    
   
      <el-form-item label="排序">
        <el-input type="number" v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink>

        <!--选择商品-->
        <Product :isproduct="isproduct" :excludeIds="exclude_ids" :islist="false" @closeDialog="closeProductFunc"></Product>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload';
import Setlink from "@/components/setlink/Setlink";
import Product from '@/components/product/Product.vue';
export default {
  components: {
    Upload,
    Setlink,
    Product
  },
  data() {
    
    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) =>{
    	if(value<1){
    		return callback(new Error('请上传活动图'));
    	}else{
         callback();
    	}
    };

    return {
       /*是否打开添加弹窗*/
        open_add: false,
      /*是否上传图片*/
      isupload: false,
      index:0,
      /*图片是否上传了*/
      rulesImage: [{ validator: validatorImages, required: true, message: '请上传图片', trigger: 'change' }],
      is_linkset:false,
      isproduct:false,
       exclude_ids:[]
    };
  },
  props: {
    form: Object,
    positionList:Array
  },
  methods: {
       /*添加商品*/
       addProduct() {
      this.isproduct = true;
    },
      /*关闭商品*/
      closeProductFunc(e) {
        let self = this;
        self.isproduct = e.openDialog;
        console.log(e)
        if (e.type == 'success') {
          self.form.product_id =  e.params.product_id
          self.form.product_name =  e.params.product_name
        }
      },


    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },
      /*获取链接并关闭弹窗*/
      closeLinkset(e) {
      this.is_linkset = false;
      if (e) {
        this.form.page_url = {
          page_url:e.url,
          name:"链接到" + " " + e.type + " " + e.name,

        }
      }
    },
        /*上传*/
        openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.image_id = e[0].file_id;
        this.form.image_url = e[0].file_path;
      }
      this.isupload = false;
    },
    add(){
      console.log(this.form)
      if(this.form.status == 2 && this.form.setting.length>=1){
        this.$message({
                message: '单图只能上传一个广告哦',
                type: 'info'
              });
        return;
      }
      this.form.setting.push({
        index:  this.form.setting.length+1,
        is_sell:0 ,
        status:1,
        price:0,
        image_url:"",
        image_id:0,
      });
      console.log('this.form.setting',this.form.setting);
    },
   

    /*获取图片*/
    // returnImgsFunc(e) {
    //   if (e != null && e.length > 0) {
    //     this.form.file_path = e[0].file_path;
    //     this.form.image_id = e[0].file_id;
    //   }
    //   this.isupload = false;
    // },
    /*打开弹出层*/
      addClick() {
        this.open_add = true;
      },
    
  }
};
</script>

<style lang="scss" scoped="scoped">
.active-basic .ad-picture {
  width: 200px;
  height: 84px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;

}
 .img {
    margin-top: 10px;
  }

  .w150{
    border: 1px solid #eee;
  }
  .tc{
    border: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/ad/ad/part/EditBasic.vue